import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'redux-little-router'

import Icon from 'discada/dist/Icon'

import { getIsLoggedIn } from 'selectors/authSelectors'
import { signOut } from 'actions/authActions'

import './NotLoggedIn.scss'

export class NotLoggedIn extends React.Component {
  componentDidMount() {
    this.props.forceLogout && this.props.signOut()
  }

  render() {
    return !this.props.isLoggedIn ? (
      <Link href="/" className="login-link" style={{ color: 'black' }}>
        <Icon icon="user-tie" /> Sign In
      </Link>
    ) : null
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    isLoggedIn: getIsLoggedIn(state),
  }
}

export default connect(
  mapStateToProps,
  { signOut },
)(NotLoggedIn)
